module.exports = __webpack_public_path__ + "static/media/sven.fcf069d6.jpg";